import { useRepositorySuspenseQuery } from '@mews-commander/data-access';

export const useGoodDataParameters = () => useRepositorySuspenseQuery('goodData', 'getParameters', {});
